import { render, staticRenderFns } from "./coderProject.vue?vue&type=template&id=6ddb54d2&scoped=true&"
import script from "./coderProject.vue?vue&type=script&lang=js&"
export * from "./coderProject.vue?vue&type=script&lang=js&"
import style0 from "./coderProject.vue?vue&type=style&index=0&id=6ddb54d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddb54d2",
  null
  
)

export default component.exports